import React, { useMemo } from 'react';
import { AlertTriangle } from 'lucide-react';

import { getFCTransferDiscrepancyGroups } from 'components/warehouse/components/fcTransfers/discrepancies/fcTransferDiscrepancyMessages';

/**
 * @param {Object} props
 * @param {Record<string, unknown> | null | undefined} props.transfer
 */
export function FCTransferDiscrepancyNotice({ transfer }) {
    const groups = useMemo(() => getFCTransferDiscrepancyGroups(transfer), [transfer]);
    if (groups.length === 0) {
        return null;
    }

    return (
        <section
            className="rounded-md border border-amber-300/70 bg-amber-50/80 px-4 py-3 text-left text-amber-950 shadow-sm"
            aria-label="Transfer discrepancies"
        >
            <div className="flex items-start gap-2">
                <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" aria-hidden />
                <div className="min-w-0">
                    <h3 className="text-sm font-semibold">Transfer discrepancies detected</h3>
                    <p className="text-sm text-amber-900/90">
                        There were discrepancies between the expected and received values for the following items.
                    </p>
                </div>
            </div>
            <div className="mt-3 space-y-3 text-sm">
                {groups.map((group) => (
                    <div key={group.groupKey}>
                        <p className="font-medium text-left">{group.itemLabel}</p>
                        <ul className="mt-1 list-disc space-y-1 pl-5 text-left">
                            {group.messages.map((message) => (
                                <li key={`${group.groupKey}-${message}`}>{message}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
}

FCTransferDiscrepancyNotice.displayName = 'FCTransferDiscrepancyNotice';
